import { Card, Skeleton } from '@tecsinapse/cortex-react'
import React from 'react'

export const LoadingCards = () => {
  const fakeArray = Array.from({ length: 4 }).fill(undefined)
  return (
    <Card className={'flex-1'}>
      <div className={'flex items-center justify-between flex-1 mb-kilo'}>
        <Skeleton className={'w-[50%] h-giga rounded-micro'} />
        <Skeleton className={'w-[30%] h-giga rounded-micro'} />
      </div>

      {fakeArray.map((_, idx) => (
        <Skeleton
          key={idx}
          className={'w-[100%] h-[7rem] mb-deca rounded-micro'}
        />
      ))}
    </Card>
  )
}
